// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1YNrMr1CZevAhEjJa3Rizo","centered":"pGAy2L-_8HBA-uGf8QBZR"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageWrapper/PageWrapper.mod.css
// module id = 1062
// module chunks = 0